"use strict";

import dispatcher from "./../dispatcher";
import {Collection} from "vwa/flux";
import poiStore from "./pois";

const poiCollaborationStore = new Collection({
	keyNames: ["poi"],
	multi: {
		keyNames:	["collaborator"]
	}
});
export default poiCollaborationStore;

window.poiCollaborationStore = poiCollaborationStore;

dispatcher.on('getPOICollaborations', (poiId, collaborations) => {
	poiCollaborationStore.get(poiId).set(collaborations);
});

dispatcher.on("updateCollaboration", (poiId, collaboration) => {
	poiCollaborationStore.get(poiId).update(collaboration.collaborator, collaboration);
});

dispatcher.on("removeCollaboration", (poiId, collaborator) => {
	poiCollaborationStore.get(poiId).remove([collaborator]);
});

dispatcher.on("addCollaboration", (poiId, collaboration) => {
	poiCollaborationStore.get(poiId).insert([collaboration]);
});

dispatcher.on("logout", () => {
	poiCollaborationStore.set(null);
});

poiStore.on('remove', pois => {
	poiCollaborationStore.remove(pois.map(p => p._id));
});


// WEBPACK FOOTER //
// ./src/store/poiCollaborations.js